import { geometric_representation_item } from "./index.js";
import { direction } from "./index.js";
import { cartesian_point } from "./index.js";
import { NVL, } from "../../step/parsing/step_deserialization_functions.js";
/* This is generated code, don't modify */
import EntityTypesAP214 from "./entity_types_ap214.gen.js";
///**
// *  */
export class cartesian_transformation_operator extends geometric_representation_item {
    get type() {
        return EntityTypesAP214.CARTESIAN_TRANSFORMATION_OPERATOR;
    }
    get description() {
        if (this.description_ === void 0) {
            this.description_ = this.extractString(1, true);
        }
        return this.description_;
    }
    get axis1() {
        if (this.axis1_ === void 0) {
            this.axis1_ = this.extractElement(2, true, direction);
        }
        return this.axis1_;
    }
    get axis2() {
        if (this.axis2_ === void 0) {
            this.axis2_ = this.extractElement(3, true, direction);
        }
        return this.axis2_;
    }
    get local_origin() {
        if (this.local_origin_ === void 0) {
            this.local_origin_ = this.extractElement(4, false, cartesian_point);
        }
        return this.local_origin_;
    }
    get scale() {
        if (this.scale_ === void 0) {
            this.scale_ = this.extractNumber(5, true);
        }
        return this.scale_;
    }
    get scl() {
        return NVL(this?.scale, 1);
    }
    constructor(localID, internalReference, model) {
        super(localID, internalReference, model);
    }
}
cartesian_transformation_operator.query = [EntityTypesAP214.CARTESIAN_TRANSFORMATION_OPERATOR, EntityTypesAP214.CARTESIAN_TRANSFORMATION_OPERATOR_2D, EntityTypesAP214.CARTESIAN_TRANSFORMATION_OPERATOR_3D];
cartesian_transformation_operator.expectedType = EntityTypesAP214.CARTESIAN_TRANSFORMATION_OPERATOR;
